//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Object.js";
import "../no/Display.js";
import "../no/DebugSession.js";
let d=[[],[[["view"],"GetViewStatistics",{R_:{viewStatistics:''}},1,0],[["fileSpec","partEid"],"ApplyVisualizationSettings",{},2,0],[["part"],"CreatePrimTestBuilder",{R_:{builder:"Display.PrimTestBuilder"}},1,0],[["fileSpec"],"LoadSessionVisualizationSettings",{},1,0],[[],"FinishSceneDataLoad",{},0,0]],[]];
SPLM.VisualizationDebugSession = class extends SPLM.Object{
    constructor (owner){
        if(owner !== undefined){
            if(owner._owner !== undefined){
                super(owner._owner);
                this._owner = owner._owner;
            }
            else{
                super(owner);
                this._owner = owner;
            }
            this._d['ObjectId'] = this._owner._d['ObjectId'];
        }
        else{
            super();
        }
        this._d['Class'] = "SPLM.VisualizationDebugSession";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.VisualizationDebugSession.ViewStatistics = class{
    constructor(dataLoaded,numFacets,numFacetVertices,numFaceEdges,numSmoothFaceEdges,numPolylines){
        this.dataLoaded=dataLoaded;this.numFacets=numFacets;this.numFacetVertices=numFacetVertices;this.numFaceEdges=numFaceEdges;this.numSmoothFaceEdges=numSmoothFaceEdges;this.numPolylines=numPolylines;}
    get Dataloaded(){return this.dataLoaded}
    set Dataloaded(val){this.dataLoaded = val}
    get Numfacets(){return this.numFacets}
    set Numfacets(val){this.numFacets = val}
    get Numfacetvertices(){return this.numFacetVertices}
    set Numfacetvertices(val){this.numFacetVertices = val}
    get Numfaceedges(){return this.numFaceEdges}
    set Numfaceedges(val){this.numFaceEdges = val}
    get Numsmoothfaceedges(){return this.numSmoothFaceEdges}
    set Numsmoothfaceedges(val){this.numSmoothFaceEdges = val}
    get Numpolylines(){return this.numPolylines}
    set Numpolylines(val){this.numPolylines = val}
};

export default SPLM;